import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TransportInfoPanelModule } from '@sdbn/appclient';
import { TransportIssuesDialogComponent } from './component/transport-issues-dialog.component';
import { CommonTranslationModule } from '@sdbn/common';
import { TmcLegacyValidatorModule } from 'src/tmc-common/validators/tmc-legacy-validator.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    TmcLegacyValidatorModule
  ],
  declarations: [TransportIssuesDialogComponent],
  exports: []
})

export class TransportIssuesModule {
}
